export default __webpack_public_path__ + "static/media/saldo-amarillo.c9b701c8.svg";